import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-user-setting',
  templateUrl: './user-setting.component.html',
  styleUrls: ['./user-setting.component.css']
})
export class UserSettingComponent implements OnInit {
  @Input() inputForm: FormGroup;
  @Input() index: number;
  selections = [];
  radioButtons = [];
  blacklist = [];
  dropdownlist = [];

  constructor(private ds: DataService) { }

  ngOnInit() {

    this.setBlacklist(this.Exclude.value);
  }

  onChangeBlackList(event) {

    this.Exclude.setValue(event);

  }

  setBlacklist(data: string[]) {
    const l = [];

    if (data) {
      data.forEach(e => {
        l.push({ value: false, text: e });
      });

      this.blacklist = l;
      this.Exclude.setValue(l);
      this.Exclude.markAsDirty();
    }
  }

  onSelected(event) {

    // console.log(event);
  }

  onSubmit(): void {
    console.log('Submit');

    if (this.Exclude.dirty) {
      this.ds.refresh = true;
      this.ds.UpdateExclusions(this.Exclude.value, this.index);
    }
  }

  get ID() {
    return this.inputForm.get('id');
  }

  get Name() {
    return this.inputForm.get('Name');
  }

  get Exclude() {
    return this.inputForm.get('Exclude');
  }
}
